export enum LayoutMode {
  Default,
  ContentOnly
}
